import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';

export const useGetWorkOrders = (closedOrders: boolean, dateFrom: Date | null) => {
    const { data, isLoading } = useQuery({
        queryKey: ['work-orders-orders', closedOrders, dateFrom],
        queryFn: async () => await apiClient.get(`work-order/dealer-orders`,
            {
                params: {
                    closedOrders: closedOrders,
                    dateFrom: dateFrom ? dateFrom.toISOString().substring(0, 10) : ''
                }
            }) as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
